// Geometry for the exported image's footer and label (F20). Pure functions, so they're testable without a canvas.

export type Point = { x: number; y: number };

/** Footer strip: font ≥ 1.6% of the image height and never below 14 px, so it stays legible at every size. */
export function footerLayout(h: number): { font: number; strip: number; pad: number; y: number } {
  const font = Math.max(14, Math.round(h * 0.016));
  const pad = Math.round(font * 0.7);
  const strip = font + pad * 2;
  return { font, strip, pad, y: h - strip };
}

/**
 * Places a label in the margin nearest the anchor (shortest leader line) and runs a line to it from the anchor.
 * The text sits level with the anchor (clamped clear of the top edge and the footer).
 */
export function labelLayout(anchor: Point, w: number, h: number, textWidth: number, font: number, footer: number): {
  side: 'left' | 'right';
  text: Point;
  lineFrom: Point;
  lineTo: Point;
} {
  const margin = Math.round(w * 0.04);
  const side = anchor.x >= w / 2 ? 'right' : 'left';
  const y = Math.min(Math.max(anchor.y, margin + font), h - footer - margin);
  const textX = side === 'left' ? margin : w - margin - textWidth;
  const lineEnd = side === 'left' ? margin + textWidth + font * 0.5 : w - margin - textWidth - font * 0.5;
  return { side, text: { x: textX, y }, lineFrom: anchor, lineTo: { x: lineEnd, y: y - font * 0.35 } };
}
